module.exports = __webpack_public_path__ + "assets/img/bc72b536b1ff08272d01f332a883fa5a.png";